import Home from './mobile/home'

const basePath = '/recruiting/personal/home'

export default {
  name: 'personalHome',
  path: `${basePath}`,
  component: Home,
  meta: {
    titleI18nKey: 'personal.home.title'
  }
}
